import { render, staticRenderFns } from "./newPressesionStepThree.vue?vue&type=template&id=4152b878&scoped=true"
import script from "./newPressesionStepThree.vue?vue&type=script&lang=js"
export * from "./newPressesionStepThree.vue?vue&type=script&lang=js"
import style0 from "./newPressesionStepThree.vue?vue&type=style&index=0&id=4152b878&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4152b878",
  null
  
)

export default component.exports